<template>
    <v-form
        ref="form"
        v-model="valid"
        class="form"
        lazy-validation
        @submit.prevent="onSubmit">
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    class="pb-0"
                    offset-md="2">
                    <v-text-field
                        v-model="formData.email"
                        :rules="emailRules"
                        label="Email"
                        prepend-inner-icon="mdi-email-outline" />
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                    md="8"
                    class="py-0"
                    offset-md="2">
                    <v-text-field
                        v-model="formData.password"
                        :rules="passwordRules"
                        label="Password"
                        prepend-inner-icon="mdi-lock-outline"
                        :type="showPassword ? 'text' : 'password'">
                        <template v-slot:append>
                            <v-btn
                                height="32"
                                icon
                                @click="showPassword = !showPassword">
                                <v-icon>{{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col
                    cols="12"
                    md="8"
                    offset-md="2"
                    class="py-0 d-flex justify-end">
                    <router-link
                        class="link"
                        to="/reset-password">
                        Forgot password?
                    </router-link>
                </v-col>
            </v-row>

            <v-row
                justify="center"
                class="mt-5">
                <v-col cols="12">
                    <v-btn
                        color="primary"
                        type="submit"
                        tile>
                        Log In
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import { validators } from '@/utils/validators';

export default {
    name: 'LoginForm',

    data() {
        return {
            valid: true,
            emailRules: [(v) => validators.required(v, 'Email'), (v) => validators.email(v)],
            passwordRules: [(v) => validators.required(v, 'Password')],
            formData: {
                email: (this.$route.query['email'] && this.$route.query['email'].replace(' ', '+')) || null,
                password: null,
            },
            showPassword: false,
        };
    },

    methods: {
        onSubmit() {
            this.$refs.form.validate();

            if (this.valid) {
                this.$store.dispatch('signIn', this.formData);
            }
        },
    },
};
</script>

<style></style>